var _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoNetwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M261,121c-3.9,0-7.6-1.7-10-4.7-1.5-1.9-36.5-42.9-102.5-42.9s-101,41.1-102.5,42.9c-4.6,5.5-12.7,6.3-18.3,1.8-5.5-4.6-6.3-12.7-1.8-18.3,1.8-2.1,43.8-52.4,122.6-52.4s120.8,50.2,122.6,52.4c4.5,5.5,3.7,13.7-1.8,18.3-2.3,1.9-5.2,2.9-8.2,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.7,155.7c-3.9,0-7.5-1.7-10-4.7-18.8-19.7-45-30.5-72.2-29.9-27.2-.6-53.4,10.3-72.2,29.9-4.8,5.4-13,5.9-18.3,1.1-5.1-4.5-5.9-12.2-1.7-17.6,23.8-25.6,57.3-39.9,92.3-39.4,34.9-.5,68.5,13.8,92.3,39.4,4.5,5.5,3.7,13.7-1.8,18.3-2.3,1.9-5.2,2.9-8.2,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.1,190.3c-4,0-7.8-1.9-10.3-5-18.6-20.6-50.4-22.3-71-3.7-1.3,1.2-2.5,2.4-3.7,3.7-4.4,5.6-12.6,6.6-18.2,2.2-5.5-4.4-6.6-12.4-2.4-18,27.2-32,75.3-35.8,107.3-8.6,3.1,2.6,6,5.5,8.6,8.6,4.3,5.7,3.3,13.8-2.4,18.2-2.3,1.7-5,2.7-7.9,2.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.5,
    cy: 220.6,
    r: 26
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 149.7,
    y: 7.2,
    width: 20.5,
    height: 285.6,
    rx: 10.3,
    ry: 10.3,
    transform: "translate(114.4 -64.5) rotate(34.8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNetwork);
export default __webpack_public_path__ + "static/media/NoNetwork.c3e70e563d6ded52228ea49fd97dccc8.svg";
export { ForwardRef as ReactComponent };